import { Link, Stack } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useRouter } from 'next/router';
import { useCallback, useEffect, useState } from 'react';

import { HoverPopper } from '@larvitu/shared/mui/ui-components';

import { NavItemDesktop } from './NavItemDesktop';

import type { NavProps } from './types';
import type { AbsoluteHoverPopperProps } from '@larvitu/shared/mui/ui-components';
import type { LinkProps } from '@mui/material';
import type React from 'react';
import type { MouseEventHandler } from 'react';

interface RootLinkStyleProps extends LinkProps {
  open?: boolean;
  active?: boolean;
  scrolling?: boolean;
  transparent?: boolean;
}

export const RootLinkStyle = styled( Link, {
  shouldForwardProp: (prop) =>
    prop !== 'active'
    && prop !== 'scrolling'
    && prop !== 'transparent'
    && prop !== 'open',
} )<RootLinkStyleProps>(
  ({
    active = false,
    scrolling = false,
    transparent = false,
    open = false,
    theme,
  }) => ({
    ...theme.typography.subtitle2,
    position: 'relative',
    fontWeight: theme.typography.fontWeightBold,
    color: theme.palette.text.primary,
    transition: theme.transitions.create( 'opacity', {
      duration: theme.transitions.duration.shortest,
    } ),
    '&:hover': {
      opacity: 0.72,
      textDecoration: 'none',
    },
    // color: active ? 'primary' : 'secondary',
    ...(active && {
      color: 'primary',
      ...(transparent && { color: theme.palette.common.white }),
      ...(scrolling && { color: theme.palette.text.primary }),
    }),
    ...(open && { color: theme.palette.primary.main }),
  }),
);

// ----------------------------------------------------------------------

export function NavDesktop({
  isScrolling = false,
  isTransparent = false,
  navConfig,
}: NavProps): React.JSX.Element {
  return (
    <Stack
      width="100%"
      pl={8}
      columnGap={8}
      direction="row"
      // spacing={6}
      sx={{
        mx: 10,
        color: 'text.secondary',
        ...(isTransparent && { color: 'inherit' }),
        ...(isScrolling && { color: 'text.secondary' }),
      }}
    >
      {navConfig.map((link, index) => (
        <NavItemDesktop
          key={`desktop${link.title}`}
          item={link}
          // isScrolling={isScrolling}
          isTransparent={isTransparent}
        />
      ))}
    </Stack>
  );
}
// ---------------------------------------------------------------------------------------------------------------------
export const RoutedHoverPopper = (
  props: AbsoluteHoverPopperProps,
): JSX.Element => {
  const { pathname } = useRouter();

  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(
    props.anchorEl ?? null,
  );

  const handleActor = useCallback<MouseEventHandler<HTMLElement>>(
    (event) => setAnchorEl( event.currentTarget ),
    [],
  );

  useEffect( () => {
    setAnchorEl( null );
  }, [pathname] );

  return <HoverPopper anchorEl={anchorEl} onOpen={handleActor} {...props} />;
};
// ----------------------------------------------------------------------
